import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Trophy, Medal, Award, Shield } from "lucide-react";

const TIER = {
  gold: { icon: Trophy, color: "border-amber-500/40 bg-amber-500/5 text-amber-300" },
  silver: { icon: Medal, color: "border-slate-500/40 bg-slate-500/5 text-slate-300" },
  bronze: { icon: Award, color: "border-orange-700/40 bg-orange-700/5 text-orange-300" },
};

export default function CarrierScorecard() {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/carrier-scorecard").then((r) => setData(r.data)); }, []);
  return (
    <div className="space-y-6 animate-slide-up" data-testid="carrier-scorecard">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-amber-600/15 border border-amber-500/20 flex items-center justify-center"><Trophy className="w-6 h-6 text-amber-400" /></div>
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-slate-500 font-bold mb-1">Insurance Intelligence</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight">Carrier Scorecard</h1>
          <p className="text-sm text-slate-400 mt-1">Performance ranking based on approval rate × payment speed · composite 0-100</p>
        </div>
      </div>
      {data.length === 0 ? <div className="text-center text-slate-500 py-12 rounded-xl border border-slate-800 bg-[#0B1120]">No carriers tracked yet. Add insurance carriers in Master Data.</div> :
      <div className="space-y-3">
        {data.map((c, i) => {
          const tier = TIER[c.tier]; const Icon = tier.icon;
          return <div key={c.name} data-testid={`carrier-${c.name.toLowerCase().replace(/\s+/g, '-')}`} className={`rounded-xl border p-5 ${tier.color}`}>
            <div className="flex items-start gap-4">
              <div className="text-[10px] uppercase tracking-wide font-bold text-slate-500 w-8 text-center pt-1">#{i+1}</div>
              <Icon className="w-8 h-8 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-display text-lg font-semibold">{c.name}</h3>
                  {c.short_code && <Badge className="bg-slate-800 border-slate-700 text-slate-400">{c.short_code}</Badge>}
                  <Badge className={tier.color}>{c.tier.toUpperCase()}</Badge>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mt-2 text-xs">
                  <Metric label="Score" value={c.composite_score} unit="/100" />
                  <Metric label="Jobs" value={c.jobs} />
                  <Metric label="Approval" value={c.approval_rate ? `${c.approval_rate}%` : "—"} />
                  <Metric label="Avg Pay Days" value={c.avg_payment_days || "—"} />
                  <Metric label="Paid Rate" value={c.paid_rate ? `${c.paid_rate}%` : "—"} />
                </div>
              </div>
              <div className="text-right shrink-0">
                <div className="font-mono font-bold text-3xl">{c.composite_score}</div>
                <div className="text-[10px] uppercase tracking-wider opacity-70">composite</div>
              </div>
            </div>
          </div>;
        })}
      </div>}
    </div>
  );
}
const Metric = ({ label, value, unit }) => <div><div className="text-[9px] uppercase tracking-wider font-bold text-slate-500">{label}</div><div className="font-mono text-sm font-semibold mt-0.5">{value}{unit||""}</div></div>;
